import distributionList from "../incomplete-distribution-list/DistributionList.vue";
import distributionDetailList from "../distribution-detaild-grid/DistributionDetailList.vue";
import distributionService from "../../services/DistributionService";
import ApiService from "../../services/ApiService";
import i18n from "../../i18n/index";
// import io from "socket.io-client";
import generateForms from '../distribution-generated-forms/generatedForms.vue'

export default {
  components: {
    distributionList,
    distributionDetailList,
    generateForms
  },
  data: () => ({
    socket: null,
    notification: i18n.t("order-pending-notification"),
    newsAdd: false,
    dialog: false,
    showGrid: false,
    menu: false,
    distributionDetail: [],
    distributionDate: new Date().toISOString().substr(0, 10),
    searchLoading: false,
    newsList: [],
    currentDistribution: null,
    location: {
      state: "",
      city: "",
      branch: "",
      scheduleRange: ""
    }
  }),
  created() {
    // this.socket = io(ApiService.getHostAndPort());
  },
  methods: {
    addNotification(suborder) {
      this.newsAdd = true;
      // this.socket.emit("SEND_NOTIFICATION", {
      //   notification: this.notification
      //     .split(":orderNumber")
      //     .join(suborder.number),
      //   providerId: suborder.idProvider.id,
      //   id: suborder.number
      // });
    },
    closeDistribution() {
      this.dialog = false;
      this.showGrid = false;
    },
    searchDistribution() {
      this.searchLoading = true;
      distributionService
        .getByDate(this.distributionDate)
        .then(response => {
          this.searchLoading = false;
          this.distributionDetail = response.data.suborders;
          this.currentDistribution = response.data.distribution;
        })
        .catch(error => {
          this.searchLoading = false;
          if (error.code === "WRONG_USER") {
            this.$notify({
              group: "app",
              type: "error",
              text: i18n.t("distribution.wrong-user")
            });
          }
        });
    },
    handleDistribution(dist) {
      this.distributionDate = dist.date;
      this.showGrid = true;
      this.searchDistribution();
    }
  }
};
